import ShippingProviderSelectItem from './ShippingProviderSelectItem';

export default ShippingProviderSelectItem;
